var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        title: "游客，您好！",
        visible: _vm.dialogVisible,
        width: "495px",
        "close-on-click-modal": false,
        "before-close": _vm.handleClose,
      },
      on: {
        "update:visible": function ($event) {
          _vm.dialogVisible = $event
        },
      },
    },
    [
      _c("div", { staticClass: "bj-welcome" }, [
        _c("span", { staticClass: "title" }, [
          _vm._v("欢迎体验WOOPER中台！温馨提醒您："),
        ]),
        _c("ul", [
          _c("li", [
            _vm._v(
              "点击“配置中心”，可进行库存结构、业务流程和规则策略等基础信息配置"
            ),
          ]),
          _c("li", [
            _vm._v(
              " 点击“业务中心”，可进行用户、渠道、商品、库存、订单、售后、财务和营销管理 "
            ),
          ]),
        ]),
        _c("p", [_vm._v("如果您体验中有任何问题，欢迎与我们联系：")]),
        _c("p", [_vm._v("服务热线：159 5912 2386")]),
        _c("p", [_vm._v("我们将竭诚为您服务！")]),
      ]),
      _c(
        "span",
        {
          staticClass: "dialog-footer flex-center",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c(
            "el-button",
            {
              staticStyle: { width: "200px" },
              attrs: { size: "medium", type: "primary" },
              on: { click: _vm.handleClose },
            },
            [_vm._v("知道了")]
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }